import { Autocomplete, Box, Grid, TextField, Typography } from '@mui/material';
import { Add as AddIcon, Close as CloseIcon } from '@mui/icons-material'
import React, { useEffect, useState } from 'react';
import WO2Button from 'src/common/components/button/Button';
import { AssetClassEnum } from 'src/common/enums';
import { useFormikContext } from 'formik';
import { CreateTemplateRequest } from '../../store';

export function AssetFields(): JSX.Element {
  const { values, setFieldValue } = useFormikContext<CreateTemplateRequest>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [availableIncludeAssetOptions, setIncludeAvailableAssetOptions] = useState<AssetClassEnum[]>(AssetClassEnum.getAllUnique());
  const [availableExcludeAssetOptions, setExcludeAvailableAssetOptions] = useState<AssetClassEnum[]>(AssetClassEnum.getAllUnique());

  const [excludeAssetClasses, setExcludeAssetClasses] = useState<AssetClassEnum[]>(
    values.excludeAssetClassIds
      .map((id) => AssetClassEnum.getById(id))
      .filter((assetClass): assetClass is AssetClassEnum => assetClass !== undefined)
  );

  const [includeAssetClasses, setIncludeAssetClasses] = useState<AssetClassEnum[]>(
    values.includeAssetClassIds
      .map((id) => AssetClassEnum.getById(id))
      .filter((assetClass): assetClass is AssetClassEnum => assetClass !== undefined)
  );  

  useEffect(() => {
    setFieldValue('excludeAssetClassIds', excludeAssetClasses.map((assetClass) => assetClass.id));
    setIncludeAvailableAssetOptions(AssetClassEnum.getAllUnique().filter((asset) => !excludeAssetClasses.includes(asset)))
  }, [excludeAssetClasses, setFieldValue, setIncludeAvailableAssetOptions]);

  useEffect(() => {
    setFieldValue('includeAssetClassIds', includeAssetClasses.map((assetClass) => assetClass.id));
    setExcludeAvailableAssetOptions(AssetClassEnum.getAllUnique().filter((asset) => !includeAssetClasses.includes(asset)))
  }, [includeAssetClasses, setFieldValue, setExcludeAvailableAssetOptions]);

  if (!isOpen) {
    return (
      <Grid item xs={12}>
        <WO2Button 
          variant={'outlined'}
          startIcon={<AddIcon/>}
          color="primary" 
          onClick={() => { setIsOpen(true) }}
        >
          <Typography variant={'h5'}>Asset class overrides</Typography>
        </WO2Button>
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <Box padding={'16px'} border={'1px solid rgba(67, 6, 250, 0.5)'} borderRadius={'25px'}>
        <Grid container justifyContent="flex-start" spacing={2}>
          <Grid item xs={10}>
            <Typography variant={'h5'}>Asset class overrides</Typography>
          </Grid>
          <Grid item xs={2} style={{textAlign: "right"}}>
            <WO2Button 
              variant={'text'}
              color="primary" 
              onClick={() => { setIsOpen(false) }}
            >
              <CloseIcon/>
            </WO2Button>
          </Grid>
          <Grid item xs={6}>
            <Typography variant={'h5'} style={{ paddingBottom: '10px', alignSelf: 'flex-start' }}>Exclude asset class</Typography>
            <Autocomplete
              noOptionsText="No items to select"
              id="excludeAssetClasses-multiselect"
              multiple
              fullWidth
              value={excludeAssetClasses}
              options={availableExcludeAssetOptions}
              getOptionLabel={(option: AssetClassEnum) => option.displayName}
              onChange={(e: React.SyntheticEvent<Element, Event>, value: AssetClassEnum[]) => setExcludeAssetClasses(value)}
              renderInput={(params) => <TextField {...params} label="" variant="outlined" fullWidth />}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant={'h5'} style={{ paddingBottom: '10px', alignSelf: 'flex-start' }}>Include asset class</Typography>
            <Autocomplete
              noOptionsText="No items to select"
              id="includeAssetClasses-multiselect"
              multiple
              fullWidth
              value={includeAssetClasses}
              options={availableIncludeAssetOptions}
              getOptionLabel={(option: AssetClassEnum) => option.displayName}
              onChange={(e: React.SyntheticEvent<Element, Event>, value: AssetClassEnum[]) => setIncludeAssetClasses(value)}
              renderInput={(params) => <TextField {...params} label="" variant="outlined" fullWidth />}
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}
